export default __webpack_public_path__ + "static/media/howtouse_plus_05_02_ko.fe68f7db.png";